import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useApp } from "../../context/AppContext";

const FloatingWhatsApp = () => {
  const { contact } = useApp();

  const raw = contact?.whatsappNumber || "9090969619"; // FALLBACK

  // NORMALIZE NUMBER FOR WA LINK
  // REMOVES SPACES, DASHES, BRACKETS, PLUS
  const cleaned = raw.toString().replace(/[^0-9]/g, "");

  // IF NUMBER LENGTH == 10, PREFIX +91 AUTOMATICALLY
  const finalNumber = cleaned.length === 10 ? `91${cleaned}` : cleaned;

  // FINAL WHATSAPP DIRECT LINK
  const whatsappLink = `https://wa.me/${finalNumber}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-50"
    >
      <div className="relative flex items-center justify-center">
        {/* YELLOW WAVES */}
        <span className="absolute w-14 h-14 rounded-full bg-[#FCC101] opacity-50 animate-ping"></span>
        <span className="absolute w-14 h-14 rounded-full bg-[#FCC101] opacity-30 animate-ping delay-200"></span>

        {/* WHATSAPP ICON */}
        <div className="bg-green-500 rounded-full p-4 shadow-lg hover:scale-110 transition-transform duration-300 relative z-10">
          <FaWhatsapp className="text-white text-3xl animate-bounce" />
        </div>
      </div>
    </a>
  );
};

export default FloatingWhatsApp;

// import React from "react";
// import { FaWhatsapp } from "react-icons/fa";

// const FloatingWhatsApp = () => {
//   // Direct chat link with number
//   const whatsappLink = "https://wa.me/9090969619";

//   return (
//     <a
//       href={whatsappLink}
//       target="_blank"
//       rel="noopener noreferrer"
//       className="fixed bottom-5 right-5 z-50"
//     >
//       <div className="relative flex items-center justify-center">
//         {/* AFSA Yellow ripple waves */}
//         <span className="absolute w-14 h-14 rounded-full bg-[#FCC101] opacity-50 animate-ping"></span>
//         <span className="absolute w-14 h-14 rounded-full bg-[#FCC101] opacity-30 animate-ping delay-200"></span>

//         {/* WhatsApp button */}
//         <div className="bg-green-500 rounded-full p-4 shadow-lg hover:scale-110 transition-transform duration-300 relative z-10">
//           <FaWhatsapp className="text-white text-3xl animate-bounce" />
//         </div>
//       </div>
//     </a>
//   );
// };

// export default FloatingWhatsApp;
